module.exports = __webpack_public_path__ + "static/media/imgJoneDone.646c3872.jpg";